import api from '@/services/api'

export async function getShipmentNoShows() {
  try {
    const response = await api.get('/shipment_no_shows')
    return response.data
  } catch (error) {
    return []
  }
}
